import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CamService } from 'src/app/services/camService/cam.service';
import { EditDivisionDialogComponent } from '../edit-division-dialog/edit-division-dialog.component';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { Division, DivisionRequest } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { Subject, takeUntil } from 'rxjs';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { NgIf, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-division-details',
    templateUrl: './division-details.component.html',
    styleUrls: ['./division-details.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatRadioGroup, MatRadioButton, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class DivisionDetailsComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['Division', 'Status', 'Actions'];

  tableData: Division[] = [];
  // dataSource = ELEMENT_DATA;
  Addnew: boolean = false;
  isLoading = true; // Start loading state
  divisionForm: FormGroup | any;

  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  private destroy$ = new Subject<void>();
  content:any;
  constructor(private fb: FormBuilder, private _camService: CamService, private router: Router, private dialog: MatDialog, private cdr: ChangeDetectorRef,
    private _ToastrApiService: ToastrApiService, public _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService, private contentService:CompanyManagementContentService) {

    this.divisionForm = this.fb.group({
      flag: ['ADD'],
      nameOfDivision: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      divisionId: [null],
      status: [true, [Validators.required]]
    })
  }

  handleEvent(event: string) {
    if (event.includes('division-details')) {
      this.Addnew = true;
    }
  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    this.getDivisionList()
  }

  getDivisionList() {
    this.isLoading = true; // Start loading state

    this._camService.GetDivisionDetails().then((res: ApiResponse<Division[]>) => {

      if (res.status == 'Success') {
        this.tableData = res.data as Division[];
      } else {
        this.tableData = [];
      }


    }).catch((err) => {

      const errMsg = err?.message || err?.error?.message || 'Something went wrong while fetching Division.';
      // this._ToastrApiService.show('error', errMsg)
      this.tableData = []; // Ensure it's empty if an error occurs
      console.error('Error:', err.error.message);

    }).finally(() => {
      this.isLoading = false; // Stop loading after API response
    });
  }



  onCancel() {
    this.Addnew = false;
    this.divisionForm.reset({ flag: 'ADD' }); // This resets the entire form
    this.divisionForm.get('status')?.setValue(true); // Set default value for status
    this._CompanyManagementService.company_management_divisionDetail('Cancel button','Cancel', this.tableData.length)//GTM

  }


  onSave() {
    this._CompanyManagementService.company_management_divisionDetail('Save button','Save', this.tableData.length)//GTM

    if (this.divisionForm.invalid) {
      return
    }

    const division: DivisionRequest = {
      flag: this.divisionForm.value.flag,
      nameOfDivision: this.divisionForm.value.nameOfDivision.trim(),
      divisionId: null,
      status: this.divisionForm.value.status
    };

    this._camService.InsertDivisionDetailsV1(division).then((res: ApiResponse<boolean>) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Division information has been saved successfully!');
          this._CompanyManagementService.save_success('Division details', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || 'Divison information has been updated!');
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }

      this.getDivisionList()
      this.Addnew = false
      this._CommonService.formResetTrigger();// Recall the component to avoid Red error showing


    }).catch((error) => {
      console.error('Error inserting division:', error);
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the Division. Please try again later.';
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  onEdit(row: Division) {
    this._CompanyManagementService.company_management_divisionDetail('Edit button','Edit', this.tableData.length)//GTM

    const dialogRef = this.dialog.open(EditDivisionDialogComponent, {
      width: '400px',
      data: { BusinessTypeID: row.businessTypeId, nameOfDivision: row.businessType, status: row.status, tabledata: this.tableData }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getDivisionList();
      } else {

      }
    });
  }



  onRemove(row: Division) {
    this._CompanyManagementService.company_management_divisionDetail('Remove button','Remove', this.tableData.length)//GTM

    this.currentItem = row;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: row, // Pass the item data
    });

  }


  confirmDelete(row: Division) {

    const request: CamDeleteModel = {
      id: row.businessTypeId,
      type: 'DIVISION'
    }

    this._camService.DeleteCAMitemBytype(request).then((res: any) => {
      if (res.status === 'Success') {
        this._ToastrApiService.show('success', res.message);

        this._CompanyManagementService.division_remove_Successfully('Confirm')//GTM
        // Filter out the deleted item directly
        this.tableData = this.tableData.filter(item => item.businessTypeId !== row.businessTypeId);
        this.currentItem = undefined;
        if (this.tableData.length === 0) {
        } else {
          this.getDivisionList();
        }
      } else {
        console.error('Error deleting item:', res.message);
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while deleting the Division. Please try again later.';
      this._ToastrApiService.show('error', errorMessage);
    });
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.division_remove('Proceed', 'Are you sure you want to remove this Division?')//GTM
    }

    if (!result) {
      this._CompanyManagementService.division_remove('Cancel', 'Are you sure you want to remove this Division?')//GTM

    }


    this.dialog.closeAll(); // Closes the dialog
  }

  addNewDivision() {
    this.Addnew = true;
    this._CompanyManagementService.company_management_divisionDetail('Add Link','Add', this.tableData.length)//GTM
    // Fully reset the form including validation state
    this.divisionForm.reset({
      flag: 'ADD',
      nameOfDivision: '',
      divisionId: null,
      status: true
    });

    // Explicitly remove all errors & touched state
    this.divisionForm.markAsPristine();
    this.divisionForm.markAsUntouched();
    this.divisionForm.updateValueAndValidity();
  }


  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

}
